import { SNARE_CONFIG } from '../constants/aafes';
export const blackBoxValueScript = () => {
  // Load device id JavaScript library
  const snareScript = document.createElement('script');
  snareScript.src = SNARE_CONFIG?.src;
  snareScript.type = SNARE_CONFIG?.type;
  snareScript.async = SNARE_CONFIG?.async;
  document.body.appendChild(snareScript);

  // Create a script for basic configuration
  snareScript.onload = () => {
    const configScript = document.createElement('script');
    configScript.type = SNARE_CONFIG?.type;
    snareScript.async = SNARE_CONFIG?.async;
    configScript.innerHTML = `
    var io_bbout_element_id = '${SNARE_CONFIG?.io_bbout_element_id}';
	var io_install_stm = ${SNARE_CONFIG?.io_install_stm}; 	
	var io_exclude_stm = ${SNARE_CONFIG?.io_exclude_stm}; 		
	var io_install_flash = ${SNARE_CONFIG?.io_install_flash}; 
	var io_enable_rip = ${SNARE_CONFIG?.io_enable_rip}; 		
	var sent = ${SNARE_CONFIG?.sent};
    `;

    document.body.appendChild(configScript);
  };
};
